import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "@/admin/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // Only admin routes need a session; skip on public respondent/preview pages to avoid 401 noise.
    if (!window.location.pathname.startsWith("/admin")) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(null);
  }, []);

  return <Ctx.Provider value={{ user, setUser, loading, logout, checkAuth }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);

export function RequireAuth({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center" style={{ background: "#F5F1E8" }}>
        <span className="text-sm" style={{ color: "#6A6256" }} data-testid="auth-loading">Memeriksa sesi…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="flex min-h-screen items-center justify-center" style={{ background: "#F5F1E8" }}>
        <div className="text-center" data-testid="forbidden">
          <h1 className="font-serif-editorial text-3xl" style={{ color: "#17140F" }}>Akses dibatasi</h1>
          <p className="mt-2 text-sm" style={{ color: "#6A6256" }}>Peran Anda tidak memiliki izin untuk halaman ini.</p>
        </div>
      </div>
    );
  }
  return children;
}
